// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Tf_g","footer":"ReportModalFilter_footer__3W6Px"};